import GLightbox from 'glightbox';

// Initialize GLightbox for flag popups
document.addEventListener('DOMContentLoaded', function() {
    // Initialize GLightbox with proper configuration
    const lightbox = GLightbox({
        selector: '.glightbox-flag',
        touchNavigation: false, // Disable touch navigation
        loop: false,
        autoplayVideos: false,
        openEffect: 'fade',
        closeEffect: 'fade',
        // Disable arrows
        showNavigation: false,
        // Disable unnecessary features
        draggable: false,
        zoomable: false
    });

    // Add custom close button functionality
    document.addEventListener('click', function(event) {
        if (event.target.classList.contains('close-modal')) {
            lightbox.close();
        }
    });

    // Make sure to update the close button functionality when content is loaded
    lightbox.on('slide_after_load', function(data) {
        const closeButtons = document.querySelectorAll('.close-modal');
        closeButtons.forEach(button => {
            button.addEventListener('click', function() {
                lightbox.close();
            });
        });
    });
});
